/*
* Project: LegalPlace assistant
* File: src/components/buy/pack_choice.js
* Author: Amine Azizi
* Version: 1.0
*/

import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  ckPaymentSelect, ckUpdatePromoCode, ckSendPromoCode, isClientPro,
} from '../../redux/actions/checkout_operations';
import PaymentModal from './payment_modal';
import CardModalNext from './card-modal-next';
import lpevents from '../../tracking/lpevents';
import { lpPattern, P_CHECK_PROMO } from '../../tracking/pattern_detector';
import lpApp from '../../app/lp_app';
import { scrollAndGoUp } from '../utils/misc';
import {
  setX3Payment, setCardPayment, setPaypalPayment, setCreatAssist, setDirectPayment,
} from '../../redux/actions/account_settings';
import LpSendInBluekOps from '../../app/ops/sendinblue_notification';
import { HARCODED_CHECKOUT_META_IDS, HARCODED_STEP_EXPERT_COMPTABLE_CHECKOUT_META_IDS } from '../../constants/hardcoded_checkout';
import PackEntrepreneur from '../buy/upsell/pack-entrepreneur';

// This one is special thing, we must change it to the CSS
const x3PaymentStyle = {
  text: {
    color: '#3392FF',
    justifyContent: 'center',
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  container: {
    margin: '14px 0',
    textAlign: 'center',
    alignItems: 'center',
    cursor: 'pointer',
  },
};

const starStyles = {
  marginRight: '5px'
};

/**
 * @description The component that selects the packs of prices.
 */
class _CePackChoiceTwoNext extends Component {
  constructor(props) {
    super(props);
    this.scrollEvent = this.scrollEvent.bind(this);
    this.sendPromo = this.sendPromo.bind(this);
    this.showCreditCardModal = this.showCreditCardModal.bind(this);
    this.toggleAssistance = this.toggleAssistance.bind(this);
    lpApp.ops.checkout.setCheckoutCallback(this.showCreditCardModal);
    this.checkoutsetPrices()
    this.executeCouponOnce = 0

    const upsellArray = this.pack && this.props.detailsCheckout[this.pack] && this.props.detailsCheckout[this.pack].upsell
    let upsell = upsellArray && upsellArray.length && [...Array(upsellArray.length)].map(() => false)
    
    // if comming from intermediate Checkout Upsell Page
    if (props.upsellArrayChecked && props.upsellArrayChecked.length)
      upsell = props.upsellArrayChecked

    this.state = {
      show_modal: false,
      show_modal1: false,
      upsell,
      pack_data: _CePackChoiceTwoNext.getPackData(props),
    };
  }

  componentDidMount() {
    document.body.classList.add('ce_checkout_v3');
    document.body.classList.add('ce_payement_v3');
    document.body.classList.add('ce_checkout_sas');
    document.body.classList.add('cc-cart--fixed');
    scrollAndGoUp();

    const sdbNotif = new LpSendInBluekOps();
    sdbNotif.sendInBlueNotification(window.obj);
    const contractAssis = [175, 197, 124, 176, 198];
    if (contractAssis.indexOf(lpApp.contractMetaId) !== -1
      && (this.props.chosen_pack === 0 || this.props.chosen_pack === 1)
    ) {
      this.refs.assistance.classList.remove('is-disabled');
      this.props.setCreatAssist(true);
      window.document.getElementById('check9').setAttribute('checked', 'checked');
    }

    const eventParams = {};
    eventParams['Reache payment'] = 'Reached PaymentPage';
    lpevents.track('Reache payment', eventParams);

    window.checkout_step = 'checkout';


    if (HARCODED_CHECKOUT_META_IDS.indexOf(lpApp.contractMetaId) > -1) {
      lpevents.trackGTMCheckoutStep(
        3,
        'Récapitulatif de votre commande',
        lpApp.getState().contract,
        lpApp.getState().checkout_operations,
        lpApp.contractMetaId,
        this.state.pack_data.packs_names
      )
    }
  }

  componentWillUnmount() {
    document.body.classList.remove('ce_checkout_v3');
    document.body.classList.remove('ce_payement_v3');
    document.body.classList.remove('ce_checkout_sas');
    document.body.classList.remove('cc-cart--fixed');
  }

  checkoutsetPrices = () => {
    switch (this.props.chosen_pack) {
      case 0: this.packPrice = +this.props.first_price;
              this.feesPack = +this.props.first_fee;
              this.pack= 'first_price';
              break;
      case 1: this.packPrice = +this.props.second_price;
              this.feesPack = +this.props.second_fee;
              this.pack= 'second_price';
              break;    
      case 3: this.packPrice = +this.props.fourth_price;
              this.feesPack = +this.props.fourth_fee;
              this.pack= 'fourth_price';
              break;    
      default: this.packPrice = +this.props.third_price;
               this.feesPack = +this.props.third_fee; 
               this.pack= 'third_price';
               break; 
    }
  }

  upsellCart = (label, price, tva = false) => 
  <div className="cart-row">
    <div className="cr-item">{label || ''} {label && tva ? 'HT' : ''}</div>
    <div className="cr-price">
      {price ? `${price.toString().replace('.',',')} €` : ''}
    </div>
  </div>
  

  getUpsellInfo = () => {
    //get upsell from  state
    const { upsell } = this.state
    // get upsell from store
    const upsellArray = this.props.detailsCheckout[this.pack].upsell
    // intialize variablse
    const upsellWithTva = []
    const upsellWithoutTva = []
    let sumUpsellTva = 0, sumUpsell = 0

    if (upsell && upsellArray && upsellArray.length) {
      for (let i=0; i<upsellArray.length; i++) {
        const {label, price, tva} = upsellArray[i]
        if (upsell[i]) {
          if (tva) {
            sumUpsellTva += +(price) * 0.2
            upsellWithTva.push(this.upsellCart(label, price.toFixed(2), tva))
          }
          else {
            upsellWithoutTva.push(this.upsellCart(label, price.toFixed(2)))
          }
            sumUpsell += +price
        }
      }
    }
    //sumUpsellTva will be added to tva
    //sumUpsell will be added to ttc
    //upsellWithTva display list before TVA
    //upsellWithoutTval display list after TVA 
    return {sumUpsellTva, sumUpsell, upsellWithTva, upsellWithoutTva}
  }
  
  calculateTVA = (sumUpsellTva) => {
    let sumTva = 0
    if (typeof this.packPrice !== 'undefined' && typeof this.pack !== 'undefined' && this.props.detailsCheckout && this.props.detailsCheckout[this.pack]) {
      const feesArray = this.props.detailsCheckout[this.pack].fees
      sumTva = +this.packPrice * 0.2
      if (feesArray && feesArray.length) {
        feesArray.forEach(feeItem => {
          if (feeItem.tva) {
            sumTva += +feeItem.price * 0.2
          }
        });
      }
    }
    sumTva += +sumUpsellTva
    return sumTva.toFixed(2)
  }

  getFeesHT = () => {
    let sumFeesHT = 0
    if (typeof this.pack !== 'undefined' && this.props.detailsCheckout && this.props.detailsCheckout[this.pack]) {
      const feesArray = this.props.detailsCheckout[this.pack].fees
      if (feesArray && feesArray.length) {
        feesArray.forEach(feeItem => {
          sumFeesHT += +feeItem.price
        })
      }
    }
    return sumFeesHT.toFixed(2)
  }

  static getPackData(props) {
    switch (lpApp.contractMetaId) {
      /*
             * Checkout SAS (175) & Checkout SASU (176)
             */
      case 198:
      case 197:
      case 175:
      case 176:
        return {
          admin_fees_detail: [
            {
              title: 'Frais de greffe obligatoire',
              fee: 66.21,
              helper: <div>Frais indépendant de LegalPlace</div>,
            }, {
              title: "Frais d'annonce légale obligatoire",
              fee: 195.00,
              helper: <div>Frais indépendant de LegalPlace</div>,
            },
          ],
          packs_names: ['Création Express', 'Création Standard', 'Statuts seuls', 'Creation Offerte'],
          packs_contents: [
            {
              title: 'Statuts de',
              dynamic: true,
              checks: [true, true, true, true],
              helper: <div> Les statuts, le M0, les pièces annexes obligatoires et le registre des bénéficiaires effectifs </div>, // eslint-disable-line
            }, {
              title: 'Vérification du dossier',
              checks: [true, true, false, true],
              helper: <div>Nos formalistes vérifient et valident votre dossier, ils prennent contact avec vous au besoin</div>, // eslint-disable-line
            }, {
              title: 'Immatriculation auprès du greffe',
              checks: [true, true, false, true],
              helper: <div>Cette formalité est obligatoire</div>,
            }, {
              title: 'Garantie anti-rejet',
              checks: [true, true, false, true],
              helper: <div>Il arrive parfois que le greffe rejette des dossiers afin de demander des informations complémentaires. Nos experts gèrent tous les cas de rejet</div>, // eslint-disable-line
            }, {
              title: "Publication de l'annonce légale",
              checks: [true, true, false, true],
              helper: <div>Cette formalité est obligatoire</div>,
            }, {
              title: 'Obtention du Kbis',
              checks: [true, true, false, true],
              helper: <div>Vous obtiendrez votre Kbis après vérification de votre dossier dans un délai de 10 jours en moyenne</div>, // eslint-disable-line
            }, {
              title: 'Traitement express (24h)',
              checks: [true, false, false, true],
              helper: <div>Nous traiterons votre dossier sous 24h. L'obtention de votre numéro SIREN peut cependant prendre 10 jours en moyenne</div>, // eslint-disable-line
            }, {
              title: 'Assistance téléphonique illimitée',
              checks: [true, false, false, true],
              helper: <div>Nos experts sont disponibles pour vous aider</div>,
            }
          ],
          Expert_comptable: [{
            title: 'Expert comptable dédié',
            checks: [false, false, false, true],
            helper: <div>Votre expert comptable dédié vous accompagne et vous conseille en permanence
            Les services inclus le bilan comptable, la déclaration de TVA, le suivi de trésorerie, etc</div>,
          }, {
            title: 'Logiciel comptable',
            checks: [false, false, false, true],
            helper: <div>Nos solutions logiciels de dernière génération automatisent jusqu’à 100% de votre comptabilité. Fini les déplacements et la « paperasse ». Vous gagnez du temps !</div>,
          },]
        };
        // SCI
      case 124:
        return {
          admin_fees_detail: [
            {
              title: 'Frais de greffe obligatoire',
              fee: 95.10,
              helper: <div>Frais indépendant de LegalPlace</div>,
            }, {
              title: "Frais d'annonce légale obligatoire",
              fee: 195.00,
              helper: <div>Frais indépendant de LegalPlace</div>,
            },
          ],
          packs_names: ['Création Express', 'Création Standard', 'Statuts seuls'],
          packs_contents: [
            {
              title: 'Statuts de',
              dynamic: true,
              checks: [true, true, true],
              helper: <div> Les statuts, le M0, les pièces annexes obligatoires et le registre des bénéficiaires effectifs </div>, // eslint-disable-line
            }, {
              title: 'Vérification du dossier',
              checks: [true, true, false],
              helper: <div>Nos formalistes vérifient et valident votre dossier, ils prennent contact avec vous au besoin</div>, // eslint-disable-line
            }, {
              title: 'Immatriculation auprès du greffe',
              checks: [true, true, false],
              helper: <div>Cette formalité est obligatoire</div>,
            }, {
              title: 'Garantie anti-rejet',
              checks: [true, true, false],
              helper: <div>Il arrive parfois que le greffe rejette des dossiers afin de demander des informations complémentaires. Nos experts gèrent tous les cas de rejet</div>, // eslint-disable-line
            }, {
              title: "Publication de l'annonce légale",
              checks: [true, true, false],
              helper: <div>Cette formalité est obligatoire</div>,
            }, {
              title: 'Obtention du Kbis',
              checks: [true, true, false],
              helper: <div>Vous obtiendrez votre Kbis après vérification de votre dossier dans un délai de 10 jours en moyenne</div>, // eslint-disable-line
            }, {
              title: 'Traitement express (24h)',
              checks: [true, false, false],
              helper: <div>Nous traiterons votre dossier sous 24h. L'obtention de votre numéro SIREN peut cependant prendre 10 jours en moyenne</div>, // eslint-disable-line
            }, {
              title: 'Assistance téléphonique illimitée',
              checks: [true, false, false],
              helper: <div>Nos experts sont disponibles pour vous aider</div>,
            },
          ],
        };
      // Rupture conventionnelle
      case 184:
        return {
          admin_fees_detail: false,
          packs_names: ['Pack sérénité', 'Pack confort', 'Pack expert'],
          packs_contents: [
            {
              title: "Dossier juridique complet",
              dynamic: false,
              checks: [true, true, true],
              helper: <div>Accord de rupture conventionnelle, Cerfa 14598 pré-rempli, Lettre de fixation de rendez-vous avec le salarié </div>
            },{
              title: "Vérification de l'ensemble du dossier par un avocat",
              checks: [true, true, false],
              helper: <div>L'avocat vérifie la conformité de votre dossier sur la base de vos pièces (contrat de travail, dernières fiches de paie)</div>
            },{
              title: "Calculs des indemnités par un avocat",
              checks: [true, true, false],
              helper: <div>L'avocat vérifie les points sensibles pour éviter un refus d'homologation sur la base des informations que vous avez renseignées</div>
            },{
              title: "Accompagnement tout au long de la procédure",
              checks: [true, false, false],
              helper: <div>L'avocat vous aide à définir la stratégie de rupture et vous accompagne tout au long de la procédure</div>
            },{
              title: "Dépot du dossier jusqu'à homologation",
              checks: [true, false, false],
              helper: <div>L'avocat vous accompagne jusqu'à la finalisation de la rupture et son homologation</div>
            },{
              title: "Signature d'un accord transactionnel (si besoin)",
              checks: [true, false, false],
              helper: <div>L'accord transactionnel vous prémunit contre les éventuelles actions prud'hommales du salarié. Cette option est recommandée en cas de situation confilictuelle avec le salarié.</div>
            }
          ]
        };

      /*
           * Auto-Entrepreneur
           */
      case 181:
        return {
          admin_fees_detail: false,
          shouldHidePhoneAssistance: true,
          shouldDisplayUpsell: true,
          upsell: [PackEntrepreneur],
          packs_names: ['Création express', 'Création Standard'],
          packs_contents: [
            {
              title: 'Dossier juridique complet',
              checks: [true, true],
              helper: (<div>
Votre dossier comprend:
                <ul>
                  <li>- votre formulaire P0</li>
                  <li>- les documents annexes requis (mal spécifié la première fois)</li>
                </ul>
              </div>),
            }, {
              title: 'Gérer les formalités administratives',
              checks: [true, true],
              helper: (<div>
                <ul>
                  <li>- Revue et validation de votre dossier par un formaliste </li>
                  <li>- Dépot de votre dossier auprès du greffe ou du CFE </li>
                  <li>- Gestion des échanges avec le greffe ou le CFE </li>
                </ul>
              </div>),
            }, {
              title: 'Obtention du numéro SIRET',
              checks: [true, true],
              helper: <div>Cette formalité est obligatoire</div>,
            }, {
              title: 'Assistance téléphonique illimitée',
              checks: [true, true],
              helper: <div>Nos experts sont disponibles pour vous aider</div>,
            }, {
              title: 'Traitement express (24h)',
              checks: [true, false],
              helper: <div>Nous traiterons votre dossier sous 24h. L'obtention de votre numéro SIRET peut cependant prendre 10 à 15 jours</div>,// eslint-disable-line
            },{
              title: 'Obtention de l\'ACRE (ex ACCRE)',
              checks: [true, false],
              helper: <div>Nous nous chargeons de compléter pour vous votre formulaire ACRE afin de vous permettre de bénéficier des réductions d'impôts dédiées au créateur d'entreprise</div>,// eslint-disable-line
            }
          ],
        };

        /*
           * Changement de siège social
           */
      case 227:
        return {
          admin_fees_detail: [
            {
              title: 'Frais de greffe obligatoire',
              fee: 195.38,
              helper: <div>Frais indépendant de LegalPlace</div>,
            }, {
              title: "Frais d'annonce légale obligatoire",
              fee: 110.00,
              helper: <div>Frais indépendant de LegalPlace</div>,
            },
             {
              title: "Frais de greffe - Modification du registre des bénéficiaires effectifs",
              fee: 46.51,
              helper: <div>Frais de greffe - Modification du registre des bénéficiaires effectifs</div>,
            },
          ],
          packs_names: ['Pack express', 'Pack Standard'],
          remove3xPayment: true,
          shouldHideReassurance: true,
          shouldHidePhoneAssistance: true,
          packs_contents: [
            {
              title: 'Vérification de votre dossier par un expert LegalPlace',
              checks: [true, true],
            }, {
              title: 'Validation et transmission de votre dossier au greffe',
              checks: [true, true],
            }, {
              title: 'Kbis mis à jour',
              checks: [true, true],
            }, {
              title: 'Mise à jour de la déclaration des bénéficiaires effectifs',
              checks: [true, true],
            }, {
              title: 'Assistance téléphonique illimitée',
              checks: [true, true],
            }, {
              title: 'Traitement express (24h)',
              checks: [true, false],
            },
          ],
        };

          /*
           * Radiation d'Auto-Entreprise
           */
        case 219:
        return {
          admin_fees_detail: false,
          packs_names: ['Radiation express', 'Radiation standard'],
          packs_contents: [
        {
          title: "Dossier juridique complet",
          checks: [true, true],
          helper: (<div>Le dossier comprend votre formulaire P2 - P4
          </div>)
        },{
          title: "Revue et validation de votre dossier par un formaliste",
          checks: [true, true],
          helper: (<div>Nos formalistes vérifient et valident votre dossier, ils prennent contact avec vous au besoin</div>)
        },{
          title: "Dépot de votre dossier auprès du greffe ou du CFE",
          checks: [true, true],
          helper: <div>Cette formalité est obligatoire</div>
        },{
          title: "Gestion des échanges avec le greffe ou le CFE",
          checks: [true, true],
          helper: <div>Des allers-retours avec l'administration sont parfois nécessaires et sont entièrement assurés par nos formalistes</div>
        },{
          title: "Assistance téléphonique illimitée",
          checks: [true, false],
          helper: <div>Nos formalistes sont joiniables pour répondre à vos questions</div>
        },{
          title: "Gestion express (moins de 48h)",
          checks: [true, false],
          helper: <div>Nous traiterons votre dossier sous 48h.</div>
        }
          ]
        }
      case 229:
        return {
          admin_fees_detail: false,
          packs_names: ['Élection simplifiée'],
          shouldHideReassurance: true,
          shouldHidePhoneAssistance: true,
          remove3xPayment: true,
          packs_contents: [
            {
              title: "Retroplanning",
              checks: [true],
            },{
              title: "Tous vos documents légaux sur-mesure",
              checks: [true],
            },{
              title: "Suivi de votre procédure par un expert",
              checks: [true],
            },{
              title: "Assistance téléphonique",
              checks: [true],
            }
          ]
        }
      case 230:
        return {
          admin_fees_detail: false,
          packs_names: ['Élection classique', 'Élection digitalisée'],
          shouldHideReassurance: true,
          shouldHidePhoneAssistance: true,
          remove3xPayment: true,
          packs_contents: [
            {
              title: "Retroplanning",
              checks: [true, true],
            },{
              title: "Tous vos documents légaux sur-mesure",
              checks: [true, true],
            },{
              title: "Suivi de votre procédure par un expert",
              checks: [true, true],
            },{
              title: "Assistance téléphonique",
              checks: [true, true],
            }, {
              title: 'Prise en charge totale de vos élections par vote électronique',
              checks: [true, true]
            }
          ]
        };
      case 231:
        return {
          admin_fees_detail: false,
          packs_names: ['Élection classique', 'Élection digitalisée'],
          shouldHideReassurance: true,
          shouldHidePhoneAssistance: true,
          remove3xPayment: true,
          packs_contents: [
            {
              title: "Retroplanning",
              checks: [true, true],
            },{
              title: "Tous vos documents légaux sur-mesure",
              checks: [true, true],
            },{
              title: "Suivi de votre procédure par un expert",
              checks: [true, true],
            },{
              title: "Assistance téléphonique",
              checks: [true, true],
            }, {
              title: 'Guide complet sur la marche à suivre pour l\'organisation de vos éléctions',
              checks: [false, true]
            }, {
              title: 'Scrutin réalisé par vote électronique',
              checks: [true, false]
            }
          ]
        };
        // ASSO
      case 162:
          return {
            admin_fees_detail: false,
            packs_names: ['Création express', 'Statuts seuls'],
            packs_contents: [
              {
                title: "Statuts d'association + Dossier complet",
                checks: [true, true],
                helper: (<div>
                  <ul>
                    <li>- Les statuts </li>
                    <li>- PV d'assemblée générale constitutive </li>
                    <li>- Bulletin d'adhésion (pour les nouveaux nembres) </li>
                    <li>- Reçu de cotisation d'adhésion </li>
                    <li>- Reçu fiscal de don (pour les déductions d'impôts en cas de don) </li>
                  </ul>
                </div>),
              }, {
                title: "Enregistrement de l'association",
                checks: [true, false],
                helper: <div>Formalité obligatoire. Frais de 44 € à payer vous-même lorsque vous recevrez une facture de l'Administration (pour la publication dans le Journal Officiel Association)</div>,// eslint-disable-line
              }, {
                title: 'Échanges avec la préfecture',
                checks: [true, false],
                helper: <div>En cas de rejet de votre dossier après instruction par les autorités administratives, nous vous assistons dans la reprise de votre dossier pour effectuer un nouveau dépôt</div>,// eslint-disable-line
              }, {
                title: 'Assistance obtention du SIRET',
                checks: [true, false],
                helper: <div>Nous vous préparons les pièces nécessaires pour l'obtention du numéro SIRET de votre association si vous envisagez d'en solliciter un (nécessaire dans certains cas)</div>,// eslint-disable-line
              }, {
                title: 'Assistance téléphonique illimitée',
                checks: [true, false],
                helper: <div>Nos experts sont disponibles pour vous aider</div>,
              }, {
                title: 'Traitement express (24h)',
                checks: [true, false],
                helper: <div>Nous traiterons votre dossier sous 24h. L'obtention de votre numéro SIRET peut cependant prendre 10 à 15 jours</div>,// eslint-disable-line
              },
            ],
          };


          /*
           * changement-denomination-sociale
           */
      case 287:
        return {
          admin_fees_detail: [
            {
              title: 'Frais de greffe obligatoire',
              fee: 242.81,
              helper: <div>Frais indépendant de LegalPlace</div>,
            }, {
              title: "Frais d'annonce légale obligatoire",
              fee: 100.00,
              helper: <div>Frais indépendant de LegalPlace</div>,
            },
          ],
          packs_names: ['Pack Express', 'Pack Standard'],
          remove3xPayment: true,
          shouldHideReassurance: true,
          shouldHidePhoneAssistance: true,
          packs_contents: [
            {
              title: 'Vérification de votre dossier par un expert LegalPlace',
              checks: [true, true],
            }, {
              title: 'Validation et transmission de votre dossier au greffe',
              checks: [true, true],
            }, {
              title: 'Kbis mis à jour',
              checks: [true, true],
            }, {
              title: 'Mise à jour de la déclaration des bénéficiaires effectifs',
              checks: [true, true],
            }, {
              title: 'Assistance téléphonique illimitée',
              checks: [true, true],
            }, {
              title: 'Traitement express (24h)',
              checks: [true, false],
            },
          ],
        };

        /*
           * Changement d'objet de société
           */
      case 296:
        return {
          admin_fees_detail: [
            {
              title: 'Frais de greffe obligatoire',
              fee: 195.00,
              helper: <div>Frais indépendant de LegalPlace</div>,
            }, {
              title: "Frais d'annonce légale obligatoire",
              fee: 125.00,
              helper: <div>Frais indépendant de LegalPlace</div>,
            },
          ],
          packs_names: ['Pack express', 'Pack Standard'],
          remove3xPayment: true,
          shouldHideReassurance: true,
          shouldHidePhoneAssistance: true,
          packs_contents: [
            {
              title: 'Vérification de votre dossier par un expert LegalPlace',
              checks: [true, true],
            }, {
              title: 'Validation et transmission de votre dossier au greffe',
              checks: [true, true],
            }, {
              title: 'Kbis mis à jour',
              checks: [true, true],
            },  {
              title: 'Assistance téléphonique illimitée',
              checks: [true, true],
            }, {
              title: 'Traitement express (24h)',
              checks: [true, false],
            },
          ],
        };
        /*
           * modifier-date-cloture-ex-social
           */
          case 301:
              return {
                admin_fees_detail: [
                  {
                    title: 'Frais de greffe obligatoire',
                    fee: 80.00,
                    helper: <div>Frais indépendant de LegalPlace</div>,
                  },
                ],
                packs_names: ['Pack express', 'Pack Standard'],
                remove3xPayment: true,
                shouldHideReassurance: true,
                shouldHidePhoneAssistance: true,
                packs_contents: [
                  {
                    title: 'Vérification de votre dossier par un expert LegalPlace',
                    checks: [true, true],
                  }, {
                    title: 'Validation et transmission de votre dossier au greffe',
                    checks: [true, true],
                  }, {
                    title: 'Kbis mis à jour',
                    checks: [true, true],
                  }, {
                    title: 'Assistance téléphonique illimitée',
                    checks: [true, true],
                  }, {
                    title: 'Traitement express (24h)',
                    checks: [true, false],
                  },
                ],
              };
        // Changement Siège Social EXT
        case 616:
        return {
          admin_fees_detail: [
            {
              title: 'Frais de greffe obligatoire',
              fee: 251.05,
              helper: <div>Frais indépendant de LegalPlace</div>,
            }, 
            {
              title: "Frais d'annonce légale obligatoire",
              subtitle: "(ancien département)",
              fee: 110.00,
              helper: <div>Frais indépendant de LegalPlace</div>,
            },
            {
              title: "Frais d'annonce légale obligatoire",
              subtitle: "(nouveau département)",
              fee: 110.00,
              helper: <div>Frais indépendant de LegalPlace</div>,
            },
             {
              title: "Frais de greffe - Modification du registre des bénéficiaires effectifs",
              fee: 46.51,
              helper: <div>Frais de greffe - Modification du registre des bénéficiaires effectifs</div>,
            },
          ],
          packs_names: ['Pack express', 'Pack Standard'],
          remove3xPayment: true,
          shouldHideReassurance: true,
          shouldHidePhoneAssistance: true,
          packs_contents: [
            {
              title: 'Vérification de votre dossier par un expert LegalPlace',
              checks: [true, true],
            }, {
              title: 'Validation et transmission de votre dossier au greffe',
              checks: [true, true],
            }, {
              title: 'Kbis mis à jour',
              checks: [true, true],
            }, {
              title: 'Mise à jour de la déclaration des bénéficiaires effectifs',
              checks: [true, true],
            }, {
              title: 'Assistance téléphonique illimitée',
              checks: [true, true],
            }, {
              title: 'Traitement express (24h)',
              checks: [true, false],
            },
          ],
        };
        // Devenir Artisan 
        case 680:
        return {
          admin_fees_detail: false,
          labelFees: 'Frais de traitement du dossier auprès de la CMA',
          shouldHidePhoneAssistance: true,
          remove3xPayment: true,
          shouldDisplayUpsell: true,
          upsell: [PackEntrepreneur],
          packs_names: ['Création express', 'Création Standard'],
          packs_contents: [
            {
              title: 'Dossier juridique complet Artisan',
              checks: [true, true],
              helper: (<div>
Votre dossier comprend:
                <ul>
                  <li>- votre formulaire P0</li>
                  <li>- les documents annexes requis (mal spécifié la première fois)</li>
                </ul>
              </div>),
            }, {
              title: 'Gérer les formalités administratives',
              checks: [true, true],
              helper: (<div>
                <ul>
                  <li>- Revue et validation de votre dossier par un formaliste </li>
                  <li>- Dépot de votre dossier auprès du greffe ou du CFE </li>
                  <li>- Gestion des échanges avec le greffe ou le CFE </li>
                </ul>
              </div>),
            }, {
              title: 'Obtention du numéro SIRET',
              checks: [true, true],
              helper: <div>Cette formalité est obligatoire</div>,
            }, {
              title: 'Assistance téléphonique illimitée',
              checks: [true, true],
              helper: <div>Nos experts sont disponibles pour vous aider</div>,
            }, {
              title: 'Traitement express (24h)',
              checks: [true, false],
              helper: <div>Nous traiterons votre dossier sous 24h. L'obtention de votre numéro SIRET peut cependant prendre 10 à 15 jours</div>,// eslint-disable-line
            },{
              title: 'Obtention de l\'ACRE (ex ACCRE)',
              checks: [true, false],
              helper: <div>Nous nous chargeons de compléter pour vous votre formulaire ACRE afin de vous permettre de bénéficier des réductions d'impôts dédiées au créateur d'entreprise</div>,// eslint-disable-line
            },
          ],
        };
      default:
        return {
          admin_fees_detail: false,
          packs_names: ['Création express', 'Statuts seuls'],
          remove3xPayment: true,
          packs_contents: [
            {
              title: "Statuts d'association + Dossier complet",
              checks: [true, true],
              helper: (<div>
                <ul>
                  <li>- Les statuts </li>
                  <li>- PV d'assemblée générale constitutive </li>
                  <li>- Bulletin d'adhésion (pour les nouveaux nembres) </li>
                  <li>- Reçu de cotisation d'adhésion </li>
                  <li>- Reçu fiscal de don (pour les déductions d'impôts en cas de don) </li>
                </ul>
              </div>),
            }, {
              title: "Enregistrement de l'association",
              checks: [true, false],
              helper: <div>Formalité obligatoire. Frais de 44 € à payer vous-même lorsque vous recevrez une facture de l'Administration (pour la publication dans le Journal Officiel Association)</div>,// eslint-disable-line
            }, {
              title: 'Échanges avec la préfecture',
              checks: [true, false],
              helper: <div>En cas de rejet de votre dossier après instruction par les autorités administratives, nous vous assistons dans la reprise de votre dossier pour effectuer un nouveau dépôt</div>,// eslint-disable-line
            }, {
              title: 'Assistance obtention du SIRET',
              checks: [true, false],
              helper: <div>Nous vous préparons les pièces nécessaires pour l'obtention du numéro SIRET de votre association si vous envisagez d'en solliciter un (nécessaire dans certains cas)</div>,// eslint-disable-line
            }, {
              title: 'Assistance téléphonique illimitée',
              checks: [true, false],
              helper: <div>Nos experts sont disponibles pour vous aider</div>,
            }, {
              title: 'Traitement express (24h)',
              checks: [true, false],
              helper: <div>Nous traiterons votre dossier sous 24h. L'obtention de votre numéro SIRET peut cependant prendre 10 à 15 jours</div>,// eslint-disable-line
            },
          ],
        };
    }
  }

  toggleAssistance(evt) {
    if (evt.target.checked) {
      this.refs.assistance.classList.remove('is-disabled');
      this.props.setCreatAssist(true);
    } else {
      this.refs.assistance.classList.add('is-disabled');
      this.props.setCreatAssist(false);
    }
  }

  toggleUpsell = (index) => {
      const upsellState = [...this.state.upsell]
      upsellState[index] = !upsellState[index]
      this.setState({ upsell: upsellState})
  }

  showCreditCardModal(isX3 = false) {
    if (typeof isX3 === 'boolean' && isX3) {
      this.props.setCard(false);
      this.props.set3X(true);
      this.props.setPaypal(false);
      this.props.setDirect(false);
      this.props.updatePaymentMethod(0);
      lpApp.ops.checkout.resetCheckedCondition();
    }
    else {
      this.props.setCard(true);
      this.props.set3X(false);
      this.props.setPaypal(false);
      this.props.setDirect(false);
      this.props.updatePaymentMethod(0);
      lpApp.ops.checkout.resetCheckedCondition();
    }

    // Tracking opened payment popup
    const eventParams = {};
    eventParams['Chosen price'] = parseFloat(lpApp.ops.checkout.getPackPrice());
    eventParams['Total price'] = parseFloat(lpApp.ops.checkout.getTTCPrice());
    eventParams['Chosen pack'] = (this.props.chosen_pack === 2) ? 'first_price' : 'second_price';
    if (lpApp.subscription && this.props.chosen_pack === 1) eventParams['Chosen pack'] = 'abonnement';
    lpevents.trackPopUpCheckout()
    lpevents.track('Opened Payment Popup', eventParams);
    if (lpApp.subscription && this.props.chosen_pack === 1) {
      this.setState({
        show_modal1: true,
       });
    } else this.setState({ show_modal: true });
  }


  /**
     * @description show and hide the payment button when the other shows up.
     */
  scrollEvent() {
    const button = document.getElementById('payment_');

    if (button.getClientRects()[0].y <= (lpApp.env.client_zone.height - 35)) {
      this.refs.one.classList.add('animate-hide');
    } else {
      this.refs.one.classList.remove('animate-hide');
    }
  }

  sendPromo() {
    this.props.checkPromo(this.props.promo_code, this.props.contract_id);
  }

  render() {
    const getContractName = (contractMetaId) => {
      switch (contractMetaId) {
        case 198:
          return 'EURL';
        case 197:
          return 'SARL';
        case 175:
          return 'SAS';
        case 176:
          return 'SASU';
        case 184:
          return "Rupture Conventionnelle";
        case 124:
          return 'SCI';
        case 162:
          return 'association';
        case 181:
          return 'auto-Entrepreneur';
        case 219:
          return "Radiation d'Auto-Entreprise";
        case 229:
          return ''

        default:
          break;
      }
    };

    isClientPro();
    const {sumUpsellTva, sumUpsell, upsellWithTva, upsellWithoutTva} = this.getUpsellInfo()

    let prixHTLabel = 'Montant total HT'

    if (lpApp.contractMetaId === 181)
      prixHTLabel = 'Création Standard HT'

    /*
         * Pack name
         */
    const packName = this.state.pack_data.packs_names[this.props.chosen_pack];

    /*
         * Pack options
         */

    const packOptions = [];
    let li;
    this.state.pack_data.packs_contents.forEach((opt, i) => {
      if ((opt.checks && opt.checks[this.props.chosen_pack] === true) || opt.display) {
        if (opt.dynamic) {
          if (lpApp.contractMetaId !== 124 && this.props.chosen_pack === 2) {
            li = (
              <li key={`pcnt-${i}`}>
                <i className="icn-checkmark" />
                <div className="pfi-text">
                  <span>
                    {opt.title }
                    {' '}
                    {getContractName(lpApp.contractMetaId)}
                  </span>
                </div>
                {(opt.helper)
                  ? (
                    <div className="wz-helper on-top">
                      {opt.helper}
                    </div>
                  )
                  : ''}
              </li>
            );
            packOptions.push(li);
            li = (
              <li key="pcnt-23">
                <i className="icn-checkmark" />
                <div className="pfi-text">
                  <span>M0</span>
                </div>
              </li>
            );
            packOptions.push(li);
            li = (
              <li key="pcnt-24">
                <i className="icn-checkmark" />
                <div className="pfi-text">
                  <span>Documents annexes</span>
                </div>
              </li>
            );
          } else {
            li = (
              <li key={`pcnt-${i}`}>
                <i className="icn-checkmark" />
                <div className="pfi-text">
                  <span>
                    {opt.title }
                    {' '}
                    {getContractName(lpApp.contractMetaId)}
                    {' '}
                    + dossier complet
                  </span>
                </div>
                {(opt.helper)
                  ? (
                    <div className="wz-helper on-top">
                      {opt.helper}
                    </div>
                  )
                  : ''}
              </li>
            );
          }
        } else {
          li = (
            <li key={`pcnt-${i}`}>
              <i className="icn-checkmark" />
              <div className="pfi-text">
                <span>{opt.title}</span>
              </div>
              {(opt.helper)
                ? (
                  <div className="wz-helper on-top">
                    {opt.helper}
                  </div>
                )
                : ''}
            </li>
          );
        }
        packOptions.push(li);
      }
    });

    // In case of reduction we show it
    if (this.props.promo_percentage && parseFloat(this.props.promo_percentage) > 0 && this.executeCouponOnce < 1) {
      this.executeCouponOnce += 1;
      this.packPrice -= (this.packPrice * this.props.promo_percentage);
    }

    // Calculating cart prices
    const totalTVA = this.calculateTVA(sumUpsellTva)
    const totalFeesHT = parseFloat(this.getFeesHT())
    const totalHT = (+this.packPrice + totalFeesHT).toFixed(2)
    const totalTTC = (parseFloat(totalHT) + parseFloat(totalTVA) + parseFloat(sumUpsell)).toFixed(2);

// 

    // Admin fees details
    let adminFeesDetails = [];
    if (this.state.pack_data.admin_fees_detail) {
      this.state.pack_data.admin_fees_detail.forEach((fee, i) => {
        const adminLi = (
          <li key={`pcnt-${i}`}>
            <i className="icn-checkmark" />
            <div className="pfi-text">
              <span>
                {fee.title}
                {' '}
-
                {' '}
                {parseFloat(fee.fee).toFixed(2).toString().replace('.',',')}
                {' '}
€ 
            {fee.subtitle &&  <span><br/>{fee.subtitle}</span>}
              </span>
            </div>
            <div className="wz-helper on-top">
              {fee.helper}
            </div>
          </li>
        );
        adminFeesDetails.push(adminLi);
      });
    } else {
      adminFeesDetails = false;
    }

    // Label fees details
    let labelFees = ""
    if (this.state.pack_data.labelFees) {
      labelFees = this.state.pack_data.labelFees
    }

    const isECSelectedPack = HARCODED_STEP_EXPERT_COMPTABLE_CHECKOUT_META_IDS.indexOf(lpApp.contractMetaId) > -1 && this.props.chosen_pack === 3

    const shouldDisplay3xPayment = !isECSelectedPack && !this.state.pack_data.remove3xPayment && totalTTC > 100 && !(this.props.promo_percentage && parseFloat(this.props.promo_percentage))

    const displayedPackPrice = parseFloat(this.packPrice).toFixed(2).toString().replace('.',',')

    const displayedPackName = isECSelectedPack ? 'Creation Express' : packName

    const shouldDisplayUpsell = (this.state.pack_data.shouldDisplayUpsell) && this.state.pack_data.upsell && (this.state.pack_data.upsell).length && this.props.detailsCheckout[this.pack].upsell && (this.props.detailsCheckout[this.pack].upsell).length 

    return (
      <div>
        <section className="checkout-core">
          <div className="container">
            <div className="checkout-container">
              <div className="cc-main">
                <div className="cc-pack-detail">
                  <div className="pack-features-extend">
                    <p className="pf-recap">Récapitulatif de votre commande</p>
                    <ul>
                      <li className="pf-title">
                        <div className="pft-text"><span>{displayedPackName}</span></div>
                        <div className="pf-price pfp-primary">
                          {this.packPrice === 0 ? 'Offert' : `${displayedPackPrice} €`}
                        </div>
                      </li>
                      {packOptions}
                    </ul>

                    {this.feesPack > 0 && (
                      <ul>
                        <li className="pf-title">
                          <div className="pft-text"><span>Frais administratifs</span></div>
                          <span className="pft-mention">(Obligatoire)</span>
                          <div className="pf-price">
                            {this.feesPack.toFixed(2).toString().replace('.',',')}
                            {' '}
€
                          </div>
                        </li>
                        <div className="pft-text"><span>{labelFees}</span></div>
                        {adminFeesDetails}
                      </ul>
                    )}
                    {isECSelectedPack && (
                      <div className="pack-features-container">
                        <ul>
                          <li className="pf-title">
                            <div className="pft-text"><span>Expert Comptable</span></div>
                          </li>
                          {this.state.pack_data.Expert_comptable.map((item, index) => (
                            <li key={`expertComptableOption-${index}`}>
                            <i className="icn-checkmark" />
                            <div className="pfi-text">
                              <span>
                                {item.title}
                                {item.subtitle &&  <span><br/>{item.subtitle}</span>}
                              </span>
                            </div>
                            <div className="wz-helper on-top">
                              {item.helper}
                            </div>
                          </li>
                          ))}
                        </ul>
                        <p className="pack-features-info-text">Vous serez contacté après le paiement pour les modalités de la solution comptable. Le prix est de 100€ par mois si paiement mensuel ou 85€ par mois si paiement annuel.</p>
                      </div>
                    )}
                  </div>
                </div>
                { shouldDisplayUpsell && this.state.pack_data.upsell.map((UpsellElt, index) => <UpsellElt index={index} checkedUpsell={this.state.upsell[index]} upsellInfo={(this.props.detailsCheckout[this.pack].upsell)[index]} toggleUpsell={this.toggleUpsell} />)
                }
                {(!this.state.pack_data.shouldHidePhoneAssistance)  && (<div className="condition-box">
                  <div className="cbx-head">
                    <p className="ch-title">Assistance LegalPlace</p>
                    <div className="lp-chbx">
                      <input type="checkbox" id="check9" onClick={this.toggleAssistance} />
                      <label htmlFor="check9"><span className="chbx-txt">(Optionnel)</span></label>
                    </div>
                  </div>
                  <div className="cbx-content is-disabled" ref="assistance">
                    <ul className="cbx-list">
                      <li>
                        <span>Appels illimités avec des juristes experts pour répondre à vos questions</span>
                        <div className="wz-helper on-top">
                          <div>Des juristes experts en droit fiscal, droit social, droit commercial, etc. sont à votre disposition par téléphone pour répondre à vos questions</div>
                        </div>
                      </li>
                      <li>
                        <span>Accès illimité à nos modèles de documents juridiques personnalisables</span>
                        <div className="wz-helper on-top">
                          <div>Notre assistant intelligent édite vos documents juridiques sur mesure : CDI, CDD, CGV, contrat de freelance, pacte d'associés, accord de confidentialité, etc.</div>
                        </div>
                      </li>
                    </ul>
                    <div className="cbx-footer">30 jours d’essai gratuit puis 29,90€/mois. Offre sans engagement, résiliable à tout moment. Vous ne serez pas débité si vous résiliez avant la fin de la période d’essai</div>
                  </div>
                </div>)}
              </div>
              <div className="cc-sidebar">
                <div className="is-sticky">
                  <div className="cc-cart lpc-desktop cc-cart--fixed">
                    <div className="cart-payement">
                      <a className="xcta cta-payement has-spinner" onClick={() => this.showCreditCardModal(false)}>
                        <i className="icn-lock" />
                        <span className="btn-text">Payez en toute sécurité</span>
                      </a>
                    </div>
                    {(shouldDisplay3xPayment) && (<div style={x3PaymentStyle.container}>
                      <a style={x3PaymentStyle.text} onClick={() => this.showCreditCardModal(true)}>
                        {' '}
ou payez en 3 fois : {(totalTTC / 3).toFixed(2).toString().replace('.',',') }
                        {' '}
€
                        {' '}
                      </a>
                    </div>)}
                    <div className="lpc-content">
                      <div className="cart-row is-title">
                        <div className="cr-item">{prixHTLabel}</div>
                        <div className="cr-price">
                          {totalHT.toString().replace('.',',')}
                          {' '}
€
                        </div>
                      </div>
                      {upsellWithTva}
                      <div className="cart-row">
                        <div className="cr-item">TVA déductible</div>
                        <div className="cr-price">
                          {totalTVA.toString().replace('.',',')}
                          {' '}
€
                        </div>
                      </div>
                      {upsellWithoutTva}
                      <div className="cart-row is-title">
                        <div className="cr-item">TOTAL TTC</div>
                        <div className="cr-price">
                          { totalTTC.toString().replace('.',',') }
                          {' '}
€
                        </div>
                      </div>
                    </div>
                    <div className="payement-methods-img">
                      <img className="img-responsive" width="163" height="25" src="/wizard/img/cc.svg" onClick={() => this.showCreditCardModal(false)} />
                    </div>


                    <div className={`cart-coupon is-open cart-coupon-md
                        ${this.props.promo_code.length > 0 ? ' focus' : ''}
                        ${this.props.promo_loading ? ' is-checking' : ''}
                        ${Number.isNaN(parseFloat(this.props.promo_percentage)) ? ' error' : ''}
                        ${(!Number.isNaN(parseFloat(this.props.promo_percentage)) && parseFloat(this.props.promo_percentage) > 0) ? ' is-valid' : ''}`}>

                      <div style={{ position: 'relative' }}>
                        <div className="input-wrapper">
                          <p>
                            Reduction de {' '+parseFloat(this.props.promo_percentage) * 100}%
                          </p>
                          <input placeholder="Code de réduction" type="text" className="form-control" onChange={evt => this.props.updatePromo(evt.target.value)} />
                        </div>
                        <button className="btn cc-btn" type="button" onClick={this.sendPromo}>
                          <span className="lpc-txt">Valider</span>
                          <span className="loading-spin" />
                        </button>
                        <div className="help-block">{this.props.promo_percentage}</div>
                      </div>

                    </div>

                  </div>

                  {!this.state.pack_data.shouldHideReassurance && (<div className="ma-wrapp">
                    <div className="marketing-args">
                      <div className="flex-media checkout-assistance">
                        <div className="fm-obj">
                          <img src="/wizard/img/ma-phone-b.svg" />
                        </div>
                        <div className="fm-body">
                          <div className="fm-title">Assistance Téléphonique</div>
                          <div className="fm-stitle">Pour tout renseignement</div>
                        </div>
                      </div>
                      {!this.state.pack_data.remove3xPayment && 
                      <div className="flex-media x3-payement">
                        <div className="fm-obj">
                          <img src="/wizard/img/ma-euro-b.svg" />
                        </div>
                        <div className="fm-body">
                          <div className="fm-title">Payez en 3 fois</div>
                          <div className="fm-stitle">Sans frais supplémentaires</div>
                        </div>
                      </div>
                        }
                      <div className="flex-media wg-avis">
                        <div className="fm-obj">
                          <img src="/wizard/img/ma-avis-b.svg" />
                        </div>
                        <div className="fm-body">
                          <div className="fm-title">Satisfaction Garantie</div>
                          <div className="fm-content">
                            <div className="rb-stars">
                              <span className="icn-star-full" />
                              <span className="icn-star-full" />
                              <span className="icn-star-full" />
                              <span className="icn-star-full" />
                              <span style={starStyles} className="icn-star-half" />
                            </div>
                            <div className="wa-avis"><a target="_blank" rel="noopener noreferrer" href="https://fr.trustpilot.com/review/legalplace.fr">sur 451 avis</a></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>)}
                </div>
              </div>
            </div>
          </div>
        </section>
        {
        <CardModalNext  packPriceWithReduction={this.packPrice} upsell = {this.state.upsell} show={this.state.show_modal} fees={this.feesPack }  totalTVA={totalTVA} totalTTC={totalTTC || null} allow3xPayment={shouldDisplay3xPayment} closeEvent={() => this.setState({ show_modal: false })}/>
        }
        <PaymentModal
          show={this.state.show_modal1}
          closeEvent={() => this.setState({ show_modal1: false })}
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  title: state.contract.name,
  first_price: state.checkout_operations.prices.first_price,
  second_price: state.checkout_operations.prices.second_price,
  third_price: state.checkout_operations.prices.third_price,
  fourth_price: state.checkout_operations.prices.fourth_price,
  first_fee: (typeof (state.checkout_operations.admin_fees) !== 'undefined') ? state.checkout_operations.admin_fees.first_price : 0,
  second_fee: (typeof (state.checkout_operations.admin_fees) !== 'undefined') ? state.checkout_operations.admin_fees.second_price : 0,
  third_fee: (typeof (state.checkout_operations.admin_fees) !== 'undefined') ? state.checkout_operations.admin_fees.third_price : 0,
  fourth_fee: (typeof (state.checkout_operations.admin_fees) !== 'undefined') ? state.checkout_operations.admin_fees.fourth_price : 0,
  detailsCheckout : state.checkout_operations.detailsCheckout,
  upsellArrayChecked: state.checkout_operations.packEntrepreneur.upsellArray,
  chosen_pack: state.checkout_operations.pack,
  pricing_loading: state.loading_details.pricing,
  has_call: state.checkout_operations.has_call,
  has_letter: state.checkout_operations.has_letter,
  letter_number: state.checkout_operations.letter.number,
  pack_price: state.checkout_operations.pack === 0
    ? state.checkout_operations.prices.first_price
    : state.checkout_operations.prices.second_price,
  promo_code: state.checkout_operations.promo_code,
  contract_id: state.checkout_operations.contract_id,
  promo_loading: state.checkout_operations.promo_loading,
  promo_percentage: state.checkout_operations.promo_percentage,
  price_loading: state.loading_details.pricing,
  client_email: state.account_settings.mail,
  card: state.account_settings.card,
  x3: state.account_settings.x3,
  paypal: state.account_settings.paypal,
  is_crea_assist_sub: state.account_settings.is_crea_assist_sub,
});

const mapDispatchToProps = dispatch => ({
  updatePaymentMethod: (meth) => {
    dispatch(ckPaymentSelect(meth));
  },
  updatePromo: (val) => {
    dispatch(ckUpdatePromoCode(val));
  },
  checkPromo: (coupon, contractId) => {
    dispatch(ckSendPromoCode(coupon, contractId));
    lpPattern.trackInPayment(P_CHECK_PROMO);
  },
  setCard: (val) => {
    dispatch(setCardPayment(val));
  },
  set3X: (val) => {
    dispatch(setX3Payment(val));
  },
  setPaypal: (val) => {
    dispatch(setPaypalPayment(val));
  },
  setDirect: (val)=>{
      dispatch(setDirectPayment(val));
  },
  setCreatAssist: (val) => {
    dispatch(setCreatAssist(val));
  },
});

const CePackChoiceTwoNext = connect(mapStateToProps, mapDispatchToProps)(_CePackChoiceTwoNext);

export default CePackChoiceTwoNext;



// WEBPACK FOOTER //
// ./src/components/buy/ce-checkout-step-two-next.js